import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { nav("/"); return; }
    let cancel = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancel) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid") {
          // auto-login with the token backend minted for the buyer
          if (data.access_token) {
            localStorage.setItem("sd_token", data.access_token);
          }
          await refresh();
          toast.success("payment received. welcome in.");
          setTimeout(() => nav("/continue"), 1000);
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) return;
        if (tries < 20) setTimeout(() => setTries((t) => t + 1), 2000);
      } catch {
        if (!cancel && tries < 10) setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancel = true; };
  }, [sessionId, tries, nav, refresh]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-success">
      <div className="text-center max-w-md">
        <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: "var(--gold)" }}>
          {status === "paid" ? "welcome" : "confirming payment"}
        </p>
        <h1 className="font-serif text-4xl mb-4" style={{ color: "var(--ink)" }}>
          {status === "paid" ? "you're in." : status === "failed" ? "payment failed" : "one moment..."}
        </h1>
        <p style={{ color: "var(--ink-soft)" }}>
          {status === "paid"
            ? "opening the course."
            : status === "failed"
            ? "your payment did not go through."
            : "we're confirming with stripe."}
        </p>
      </div>
    </div>
  );
}
